<template>
  <div class="how-section__wrapper">
    <h2 class="how-section__title subtitle-1">HOW?</h2>

    <p class="how-section__description text-body">
      Explore How to Tap into a Thriving Network of Fintech Enthusiasts and
      Experts: Uncover the secrets of connecting with a community actively
      seeking information on businesses and services like yours. Learn to engage
      with an elite and extensive group of fintech professionals through our
      distinctive portals and a variety of activities, tailored to foster
      meaningful connections in the fintech world.
    </p>

    <div class="how-section__what-we-offer">
      <h2 class="how-section__title subtitle-1">WHAT WE OFFER</h2>

      <homepage-how-section-list />
    </div>

    <a-icon
      :icon="$options.consts.ICON.BACKGROUND_DOTS_1"
      width="auto"
      height="auto"
      :no-hover="true"
      :original="true"
      class="how-section__background-icon"
    />

    <a-visibility show :from="$breakpoint.desktopMd">
      <rotatable-svg-element-on-scroll
        :icon="$options.consts.ICON.BACKGROUND_SHAPE_2"
        :animated-data-ids="$options.consts.ANIMATED_DATA_IDS"
        class="how-section__background-shape"
      />
    </a-visibility>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { ANIMATED_ELEMENT_DATA_ID } from 'enums/animated-background-shape-id'
import HomepageHowSectionList from '@/components/_homepage/HomepageHowSection/HomepageHowSectionList/index.vue'
import RotatableSvgElementOnScroll from '@/components/_homepage/shared/RotatableSvgElementOnScroll/index.vue'
import { generateServerCacheKey } from '@/plugins/helper'

export default {
  name: 'HomepageHowSection',
  serverCacheKey: () => generateServerCacheKey('HomepageHowSection'),
  components: {
    RotatableSvgElementOnScroll,
    AIcon,
    HomepageHowSectionList
  },
  consts: {
    ICON,
    ANIMATED_DATA_IDS: [ANIMATED_ELEMENT_DATA_ID.SHAPE_2]
  }
}
</script>

<style lang="scss" scoped>
.how-section__wrapper {
  position: relative;
  background: $c--blue-light-1;

  $margin-x: (
    $above-desktop-xl: -#{$padding-x-desktop-full-hd},
    $desktop-sm: -#{$padding-x-desktop-sm},
    $mobile: -#{$padding-x-mobile}
  );

  $padding: (
    $above-desktop-xl: 65px $padding-x-desktop-full-hd
      $padding-x-desktop-full-hd,
    $desktop-sm: 52px $padding-x-desktop-sm 60px,
    $mobile: 22px $padding-x-mobile 28px
  );

  @include setStyleByBreakpoint('margin-left', $margin-x);
  @include setStyleByBreakpoint('margin-right', $margin-x);
  @include setStyleByBreakpoint('padding', $padding);

  .how-section__description {
    $margin-top: (
      $above-desktop-xl: 40px,
      $desktop-sm: 25px,
      $mobile: 14px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }

  .how-section__what-we-offer {
    position: relative;
    border-radius: 50px;
    background: $c--white;
    box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.12);
    z-index: 1;

    $margin: (
      $above-desktop-xl: 63px -63px 0,
      $desktop-sm: 40px -24px 0,
      $mobile: 32px -11px 0
    );

    $padding: (
      $above-desktop-xl: 38px 63px 56px 71px,
      $desktop-sm: 31px 24px 39px 24px,
      $mobile: 13px 11px 19px 11px
    );

    $border-radius: (
      $above-desktop-xl: 50px,
      $desktop-sm: 40px,
      $mobile: 30px
    );

    @include setStyleByBreakpoint('margin', $margin);
    @include setStyleByBreakpoint('padding', $padding);
    @include setStyleByBreakpoint('border-radius', $border-radius);
  }

  .how-section__background-icon {
    position: absolute;
    transform: translateY(50%);

    $width: (
      $above-desktop-xl: 144px,
      $desktop-sm: 81px,
      $mobile: 46px
    );

    $height: (
      $above-desktop-xl: 128px,
      $desktop-sm: 72px,
      $mobile: 42px
    );

    $bottom: (
      $above-desktop-xl: 0
    );

    $left: (
      $above-desktop-xl: 40px,
      $desktop-sm: 16px,
      $mobile: 9px
    );

    @include setStyleByBreakpoint('width', $width);
    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('bottom', $bottom);
    @include setStyleByBreakpoint('left', $left);
  }

  .how-section__background-shape {
    position: absolute;
    top: 145px;
    left: 0;
    height: 591px;
    width: 280px;
    z-index: 0;
  }
}
</style>
